import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Services from "./Services";
import HowItWorks from "./HowItWorks";
import Aboutus from "./Aboutus";
import Contactus from "./Contactus";
import WhyChooseUs from "./WhyChooseUs";
import girlReading from "./images/girl-reading.svg";
import Footer from "./Footer";

function Home({ data }) {
  return (
    <div className="home">
      <Header />
      <section className="intro">
        <div className="flex-2">
          <div className="place-left">
            <h1>learning made easy</h1>
            <p>
              Learning is spontaneous and a gradual process. We are here to help
              you inculcate and breed the spirit of learning in you.
            </p>
            <div className="cta-btn">
              <Link to="/signup">get started</Link>
            </div>
          </div>
          <div className="place-right">
            <div className="img-container">
              <img src={girlReading} alt={"a girl in the library"} />
            </div>
          </div>
        </div>
      </section>

      {/* why cba */}
      <WhyChooseUs Features={data.features} />

      {/* abouts us */}
      <Aboutus />

      {/* services */}
      <Services Services={data.services} />

      {/* How the app works */}
      <HowItWorks />

      {/* Contact us */}
      <Contactus contactDetails={data.contactus} />

      {/*Footer */}
      <Footer icons={data.icons} />
    </div>
  );
}

export default Home;
